import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getRoles(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.ROLES.GET_ROLES, action.payload, true);
}

export function* getRolePermissions(action: any): any {
  const { roleId } = action.payload;
  const apiUrl = `${API_URL.ROLES.GET_ROLE_PERMISSIONS(roleId)}`;
  yield call(sagaFunction, action, CallApi.GET, apiUrl, null, true);
}
